// extracted by mini-css-extract-plugin
module.exports = {"label":"ImageFloatingLabel_label__9fFG2"};